"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebmBase = void 0;
class WebmBase {
    constructor(name = "Unknown", start = 0) {
        this.name = name;
        this.start = start;
    }
    getType() {
        return "Unknown";
    }
    updateBySource() {
        // NOOP
    }
    setSource(source) {
        this.source = source;
        this.updateBySource();
    }
    updateByData() {
        // NOOP
    }
    setData(data) {
        this.data = data;
        this.updateByData();
    }
    getValue() {
        return this.data;
    }
    setValue(value) {
        this.setData(value);
    }
}
exports.WebmBase = WebmBase;
//# sourceMappingURL=WebmBase.js.map